import React from "react";

export default function PaperCharm({ kind, className = "" }) {
  return <span className={`paper-charm paper-charm-${kind} ${className}`} aria-hidden="true" />;
}
